import { SearchField } from "@/modules/common/components";
import { ChangeTypes, EventFiltersType, FiltersChangeType } from "@/modules/eventsV2/hooks";

interface TableFiltersProps {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}

export function InventoryTableFilters({
  filters,
  onFilters,
}: TableFiltersProps) {
  return (
    <div className="flex gap-4">
      <SearchField
        placeholder="Search by category, name, or nickname"
        defaultValue={filters.search || ''}
        className="w-full max-w-[300px]"
        onChange={(value) => onFilters({ search: value }, ChangeTypes.Debounce)}
      />
    </div>
  );
}
